module.exports = __webpack_public_path__ + "static/media/testimonials1.77f04b33.png";